import IPInput from './IPInput'

export default IPInput
